import { initializeApp, FirebaseApp } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";
import { getFirestore, Firestore } from "firebase/firestore";
import { getFunctions, Functions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyC4nk6ks5Rb84L1WHiTRxLN7CA-MHcYPMw",
  authDomain: "sidescribe-bacca.firebaseapp.com",
  projectId: "sidescribe-bacca",
  storageBucket: "sidescribe-bacca.firebasestorage.app",
  messagingSenderId: "532086325167",
  appId: "1:532086325167:web:985154660c2c7cd8dd795a",
  measurementId: "G-H93YXE31WP",
};

const app: FirebaseApp = initializeApp(firebaseConfig);
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const functions: Functions = getFunctions(app);
